import { GetAdjusterOtherDamagedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAdjusterOtherDamagedImages/getAdjusterOtherDamagedImagesQuery.type';
import { getAdjusterOtherDamagedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAdjusterOtherDamagedImages/getAdjusterOtherDamagedImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getAdjusterOtherDamagedImagesQueryOptions = (
  params: GetAdjusterOtherDamagedImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['adjusterOtherDamagedImages', params],
    queryFn: () => getAdjusterOtherDamagedImagesFunction(params),
    enabled: true,
  });
};
